import { Dtos, ErrorKey, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ApiError } from "../../../utils/error";
import { useRequest } from "../../../utils/request";
import { bondRequestIssuanceQueryKey, bondRequestsQueryKey } from "../bond-request.keys";
import { redirectToIssuedBond } from "../utils";

export const useFetchAdminBondIssuance = (accountId: SuretyAccountId, quoteId: SuretyQuoteId) => {
	const queryClient = useQueryClient();
	const { get } = useRequest();

	const { data, error, isLoading } = useQuery({
		queryKey: bondRequestIssuanceQueryKey(quoteId),
		queryFn: async () => {
			try {
				return await get<Dtos.SuretyBondIssuance.Get.Response>(
					`/v2/admin/surety/accounts/${accountId}/quotes/${quoteId}/issuance`,
				);
			} catch (error) {
				if (error instanceof ApiError) {
					if (error.key === ErrorKey.bond_request_already_closed) {
						void queryClient.invalidateQueries({
							queryKey: bondRequestsQueryKey(quoteId),
							exact: true,
						});
						return null;
					}
					if (error.statusCode === 404) {
						return null;
					}
				}
				throw error;
			}
		},
		retry: false,
		meta: { redirectOnError: redirectToIssuedBond },
	});

	return {
		bondIssuance: data,
		bondIssuanceError: error,
		bondIssuanceIsLoading: isLoading,
	};
};
